import { Ref, RefObject, useEffect } from 'react';

const useClickOutside = (
  ref: RefObject<HTMLDivElement> | null,
  showFunc: (show: boolean) => void
) => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref?.current && !ref?.current.contains(e.target as Node)) {
        showFunc(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref]);
};

export default useClickOutside;
